<template>
	<div id="menuMange">
		<div id="pagesite" v-loading="listLoading" class="public-content">
			<div class="title">
				<i class="el-icon-document"></i>
				数据列表
				<div class="fr">
					<el-button type='primary' size="small" @click="addTop">新增顶级菜单</el-button>
				</div>
			</div>
			<!-- <ul class="th">
				<li class="name">菜单名称</li>
				<li class="path">菜单类型</li>
				<li class="componentPath">页面路由</li>
				<li class="isShow">可见</li>
				<li class="sign">标识</li>
				<li class="option">操作</li>
			</ul>
			<div class="treeList" id="notFolderTreeList">
				<ul id="tree" v-for="(model, index) in treeDatas" :key="index">
					<page-item
						class="item"
						:model="model"
						@add="listenAdd">
					</page-item>
				</ul>
			</div> -->
			<!-- 表格 -->
				<el-table
				    :data="treeDatas"
				    style="width: 100%;margin-bottom: 20px;"
				    row-key="id"
				    border
				    :header-cell-style="{background:'#ec681d',color:'#fff'}"
				    default-expand-all
				    :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				    <el-table-column
				      prop="name"
				      label="菜单名称"
				      width="180">
				    </el-table-column>
				    <el-table-column
				      prop="genre"
				      label="菜单类型"
				      width="180">
				      <template slot-scope="scope">
				      		{{ scope.row.genre==1?"菜单":scope.row.genre==2?'按钮':scope.row.genre==3?"权限":"-"}}
				      	</template>
				    </el-table-column>
				    <el-table-column
				      prop="href"
				      label="页面路由">
				    </el-table-column>
				     <el-table-column
				      prop="isShow"
				      label="可见">
				      	<template slot-scope="scope">
				      		{{ scope.row.isShow==1?"可见":"隐藏"}}
				      	</template>
				    </el-table-column>
				     <el-table-column
				      prop="permission"
				      label="标识">
				    </el-table-column>
				     <el-table-column
				      prop="address"
				      width='380'
				      label="操作">
				      	<template slot-scope="scope">
				      		<span >
								<el-button type='warning' size="mini" @click="handleCommand('modify',scope.row)" class='elButton'>编辑</el-button>
								<el-button class='minButton elButton' size="mini" @click="handleCommand('add',scope.row)">新增下级</el-button>
								<el-button type="danger" size="mini" @click="handleCommand('remove',scope.row)" class='elButton'>删除</el-button>
								<el-button type="danger" size="mini" @click="handleCommand('synchro',scope.row)" class='elButton'>同步到角色</el-button>
						</span>
				      	</template>
				    </el-table-column>
				  </el-table>



				  <!-- 表格结束======================================================= -->


		</div>
		<el-dialog :title="title" :visible.sync="isTree" width="500px" :close-on-click-modal="false">
			<div class="chooseTree">
				<el-tree :data="treeDatas" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
			</div>
			<span slot="footer" class="dialog-footer">
			    <el-button @click="isTree = false">取 消</el-button>
			    <el-button class='minButton' @click="confirmMenu">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 新增/编辑菜单 -->
		<el-dialog :title="title" :visible.sync="isBomb" width="500px" :close-on-click-modal="false">
			<el-form label-width="80px">
				<el-form-item label="菜单名称">
					<el-input v-model="menuName" size='small'></el-input>
				</el-form-item>
				<el-form-item label="上级菜单">
					<el-input v-model="parentName" size='small' @focus="chooseParent"></el-input>
				</el-form-item>
				<!-- <el-form-item label="菜单路由">
					<el-input v-model="menuPath" size='small'></el-input>
				</el-form-item> -->
				<el-form-item label="页面路由">
					<el-input v-model="componentPath" size='small'></el-input>
				</el-form-item>
				<el-form-item label="菜单图标">
					<el-input v-model="menuIcon" size='small'></el-input>
				</el-form-item>
				<el-form-item label="是否可见">
					<el-switch v-model="isShow" active-text="显示" inactive-text="隐藏"></el-switch>
				</el-form-item>
				<el-form-item label="菜单类型">
					<el-select v-model="genre" placeholder="请选择">
				      <el-option label="菜单" value="1"></el-option>
				      <el-option label="按钮" value="2"></el-option>
				      <el-option label="权限" value="3"></el-option>
				    </el-select>

				</el-form-item>
				<el-form-item label="菜单标识">
					<el-input v-model="menuSign" size='small'></el-input>
				</el-form-item>
				<el-form-item label="方法名">
					<el-input v-model="functions" size='small'></el-input>
				</el-form-item>
				<el-form-item label="排序">
					<el-input v-model="sort" size='small'></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
			    <el-button @click="isBomb = false">取 消</el-button>
			    <el-button class='minButton' @click="saveMenu">确 定</el-button>
			</span>
		</el-dialog>


		<!-- 同步菜单到角色 -->
		<el-dialog :title="title" :visible.sync="synchro" width="500px" :close-on-click-modal="false">
			<el-form label-width="120px" >
				<!-- <el-form-item label="同步菜单到角色">
					<el-input v-model="menuName" size='small'></el-input>
				</el-form-item> -->

				<el-form-item label="是否模板角色">
					<el-switch v-model="isTemplate"  @change="changTemple" active-text="是" inactive-text="否"></el-switch>
				</el-form-item>

				<el-form-item v-if="!isTemplate" label="账套名称">
					<el-select size="mini" v-model="bookId" placeholder="请选择" @change="selectBook(bookId)" filterable>
						<el-option v-for="(item,index) in this.chooseSetBook" :key="index" :label="item.bookName" :value="item.bookId">

						</el-option>
					</el-select>
				</el-form-item>


				<el-form-item label="同步的角色">
				<el-select v-model="roleIds" size="mini" multiple placeholder="请选择" filterable>
				    	<el-option v-for="(item,index) in this.chooseRole" :key="index" :label="item.name" :value="item.id">

						</el-option>
				</el-select>
			</el-form-item>
		</el-form>
			<span slot="footer" class="dialog-footer">
			    <el-button @click="synchro = false">取 消</el-button>
			    <el-button class='minButton' @click="synchroRole">确 定</el-button>
			</span>
		</el-dialog>


	</div>
</template>

<script>
import pageItem from "@/components/Set/pageitem"
export default {
	components: {
		pageItem
	},
	data() {
		return {
			temporary:{},
			treeDatas: [],
			isBomb: false,
			synchro:false,
			isTemplate:true,
			chooseSetBook:[],
			bookId:"",
			roleIds:[],
			chooseRole:[],
			title: "新增菜单",
			menuName: '',
			componentPath: '',
			parentName:'',
			parentId:'',
			menuSign:'',
			menuId:'',
			isShow:true,
			sort:'',
			genre:'1',
			menuIcon: '',
			functions:'',
			isTree:false,
			defaultProps: {
		        children: 'children',
		        label: 'label'
   			},
   			listLoading: false
		}
	},
	methods: {
		//d表格操作
		handleCommand(command,row) {
				let _this = this,data={};
				if(command == "add") {
					 data = {
						type:command,
						title:'新增菜单'	,
						id:'',
						name:'',	
						parent:row.name,
						parentId:row.id,
						componentPath: '',
						sign:'',
						genre:'1',
						sort:'',
						isShow:1,
						icon: '',
					};
				} else if(command == "modify") {
					 data = {
						type:command,
						title:'编辑菜单',
						id:row.id,
						name:row.name,
						componentPath: row.href,
						parent:'',
						sign:row.permission,
						parentId:row.fkParantId,
						isShow:row.isShow,
						sort:row.sort,
						genre:row.genre,
						functions:row.function,
						icon: row.icon
					};
				} else if(command == "remove") {
					 data = {
						type:command,
						id:row.id,
					}
				}else if(command == "synchro"){
					 data = {
						title:'同步菜单到角色',
						type:command,
						id:row.id
						
					}
				}
				this.listenAdd(data);
			},
			// 获取表格数据
		getMenu(){
			let _ = this;
			let params = {
				haveButtons:'1'
			}
			_.$http.post('sys/menu/getTree',{ isButton: '2'}).then(res=>{
				_.treeDatas = res.data.data;

			})
		},

		changTemple(){
			if(!this.isTemplate){
					this.roleIds=[];
					this.chooseRole=[];
				this.$http.post('sys/login/getAllBooks',{}).then(res=>{
					this.chooseSetBook=res.data.data;
				})
			}else{
				this.getChooseRole("1");
			}
		},
		selectBook(bookId){
			this.getChooseRole("2",bookId);
		},

		//同步菜单到角色
		synchroRole(){
			let params = {
					menuId:this.menuId,
					isTemplate:'1',
					roleIds:"",
			}
			if(this.isTemplate){
				params.isTemplate="1";
			}else{
				params.isTemplate="2";
			}

			for(var i=0 ;i< this.roleIds.length;i++){
				if(""==params.roleIds){
					params.roleIds=this.roleIds[i];
				}else{
					params.roleIds=params.roleIds+","+this.roleIds[i];
				}

			}


			this.$http.post('/sys/role/allocationMenuToRole',params).then(res=>{
					if(res.data.code == '1'){
							this.synchro = false;
							this.$message({
								type: 'success',
								message: '保存成功！',
								showClose: true
							})

						}else {
							this.synchro = true;
						}
			})


		},
		getChooseRole(type,bookId){
				let params = {
					type:type,
					bookId:bookId
				}

				this.roleIds=[];
				this.$http.post('/sys/role/getSpecifiedRole',params).then(res=>{
					this.chooseRole= res.data.data;
				})
		},

		addTop(){
			this.title = '新增菜单'
			this.menuName = '';
			this.parentName = '';
			this.componentPath= '';
			this.parentId = '';
			this.menuIcon = '';
			this.isShow = true;
			this.menuSign = '';
			this.functions = '';
			this.menuId = '';
			this.genre='1',
			this.sort = '';
			this.$nextTick(() => {
				this.isBomb = true;
			})
		},
		saveMenu() {
			let params = {
				id:this.menuId,
				fkParantId:this.parentId,
				name:this.menuName,
				permission:this.menuSign,
				isShow:this.isShow,
				href: this.componentPath,
				sort:this.sort,
				genre:this.genre,
				function:this.functions,
				icon: this.menuIcon
			}


			if(params.isShow){
				params.isShow = 1;
			}else{
				params.isShow = 0;
			}
			try {
				console.log(params)
				this.$http.post('sys/menu/save',params).then(res=>{
						if(res.data.code == '1'){
							this.isBomb = false;
							this.$message({
								type: 'success',
								message: '保存成功！',
								showClose: true
							})
							this.getMenu();
						}else {
							this.isBomb = false;
						}


				})
			}catch(e){
				this.isBomb = false;
			}


		},
		listenAdd(data) {
			this.title = data.title;

			if(data.type == 'remove'){
				let params = {id: data.id}
				this.$confirm('此操作将永久删除该菜单, 是否继续?', '提示', {
		          	confirmButtonText: '确定',
		          	cancelButtonText: '取消',
		          	type: 'warning'
		        }).then(() => {
		          	this.$http.post('sys/menu/del',params).then(res=>{
						if(res.data.code == '1'){
							this.isBomb = false;
							this.$message({
								type: 'success',
								message: '删除成功！',
								showClose: true
							})
							this.getMenu();
						}else {
							this.isBomb = false;
						}
					})
		        }).catch(() => {

		        });
			}else if(data.type == 'synchro'){
				this.synchro = true;
				this.isTemplate=true,
				this.bookId ='',
				this.menuId = data.id;
				this.getChooseRole("1");

			} else{
				this.isBomb = true;
				this.menuName = data.name;
				this.componentPath = data.componentPath;
				this.parentName = data.parent;
				this.menuSign = data.sign;
				this.menuId = data.id;
				this.parentId = data.parentId;
				this.sort = data.sort;
				this.genre = data.genre?data.genre.toString():'1';
				this.functions = data.functions;
				this.menuIcon = data.icon;
				if(data.isShow == '1'){
					this.isShow = true
				}else{
					this.isShow = false
				}
			}
		},
		chooseParent(){
			this.isTree = true;
		},
		confirmMenu(){
			this.parentId = this.temporary.id;
			this.parentName = this.temporary.label;
			this.isTree = false;
		},
		handleNodeClick(data) {
   			this.temporary = data;
  		}
	},
	created(){
		this.getMenu()
	},
	watch: {
		$route (to, from) {
			if(this.$route.path == '/menuManage'){
				this.getMenu();
			}
		}
	}
}
</script>

<style lang="less">
#menuMange {
	ul, ol {
		list-style: none;
	}
	color: #4B4B4B;
	#pagesite {
		font-size: 16px;
		color: #555;
		margin: 20px;
		.title{
			background-color: #fff;
			height: 60px;
			line-height: 40px;
			font-size: 18px;
			font-weight: bold;
			color: #EC681D;
			.el-icon-document {
				font-size: 20px;
			}
		}
		.th{
			border-radius: 5px 5px 0 0;
			border-top:1px solid #E9E9E9 ;
			border-left: 1px solid #E9E9E9;
			background-color: #EC681D;
			padding: 0;
			color:#fff;
			height: 50px;
			&:after{
				height: 0;
				content: '';
				clear: both;
				display: block;
			}
			li{
				box-sizing:border-box;
				-moz-box-sizing:border-box; /* Firefox */
				-webkit-box-sizing:border-box; /* Safari */
				float: left;
				height: 50px;
				line-height: 50px;
				text-align: center;

				border-right:1px solid #E9E9E9;
			}
			.name{
 				width: 16.6666666667%;
			}
			.path{
 				width: 5%;
			}
			.componentPath{
 				width: 16%;
			}
			.isShow{
 				width: 5%;
			}
			.sign{
 				width: 16%;
			}
			.option {
				 width: 41.333% ;
			}

		}
		.treeList{
			border-bottom: 1px solid #E9E9E9;
			#tree {
				background-color:#fff;
				list-style: none;
			}
		}
    
	}
	.addItem {
		height: 40px;
		font: normal 14px/40px "微软雅黑";
		padding: 0 20px;
		height: 50px;
		line-height: 50px;
		>span {
			display: inline-block;
			width: 100px;
		}
		.el-input {
			width: 220px;
		}
	}
	.chooseTree{
		height: 500px;
		overflow: auto;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/setting/menuManage.vue